import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Videocard from 'components/items/videocard';
import Topvideos from 'components/topvideos/Topvideos';
import _get from 'lodash.get';
import s from './Videosearch.scss';
import { loadVideosearchDataCount } from '../../reduxUtils/modules/videosearch';

const config = { perpage: 20, maxSearchPageToShow: 6 };
class Videosearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNum: 1,
      activeSorting: 'score desc',
    };
  }
  _getSearchPageCount = (startIndex, resultCount) => {
    const pageCountArray = [];
    if (resultCount === 0) {
      return pageCountArray;
    }
    const maxResultsPerPage = config.perpage;
    let maxPagesCount = resultCount / maxResultsPerPage;
    maxPagesCount = Math.ceil(maxPagesCount);
    maxPagesCount = maxPagesCount > 100 ? 100 : maxPagesCount;
    //util._setMaxPageCount(maxPagesCount);
    let pageCountToShow =
      maxPagesCount < config.maxSearchPageToShow
        ? maxPagesCount
        : config.maxSearchPageToShow;
    pageCountToShow =
      pageCountToShow + startIndex < maxPagesCount
        ? pageCountToShow + startIndex
        : maxPagesCount;

    for (let i = startIndex; i <= pageCountToShow; i += 1) {
      pageCountArray.push({ pageNum: i });
    }
    return pageCountArray;
  };
  decrementPage = e => {
    e.preventDefault();
    if (this.state.pageNum > 0) {
      this.handlePageChange(this.state.pageNum - 1);
      this.setState({ pageNum: this.state.pageNum - 1 });
    }
  };
  incrementPage = e => {
    e.preventDefault();
    this.handlePageChange(this.state.pageNum + 1);
    this.setState({ pageNum: this.state.pageNum + 1 });
  };
  changesortorder = e => {
    e.preventDefault();
    const sortorder = e.target.getAttribute('data-sort-ordrer');
    this.setState({ activeSorting: sortorder, pageNum: 1 });
    const queryparams = {
      searchitem: this.props.data.Header.Params.q,
      sortorder,
      isWapView: this.props.isMobile,
    };
    this.props.loadVideosearchDataCount(queryparams);
  };
  handlePageChangeevent = (e, page) => {
    e.preventDefault();
    this.handlePageChange(page);
  };
  handlePageChange = page => {
    this.setState({ pageNum: page });
    const queryparams = {
      searchitem: this.props.data.Header.Params.q,
      pageNum: page,
      sortorder: this.state.activeSorting,
    };
    this.props.loadVideosearchDataCount(queryparams);
  };

  _getDescriptionFromXml = xml => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = xml;
    const description = tempDiv.querySelectorAll('largedescription')[0]
      .innerText;
    return description;
  };
  _convertMsToReadableTime = miliSeconds => {
    let readableTime;
    // eslint-disable-next-line no-restricted-globals
    if (!miliSeconds || isNaN(miliSeconds) || miliSeconds < 0) {
      readableTime = '';
    }
    const totalSeonds = miliSeconds / 1000;
    const minutes = totalSeonds / 60;
    let seconds = totalSeonds % 60;

    // eslint-disable-next-line radix
    seconds = parseInt(seconds) > 9 ? seconds : `0${seconds}`;

    // eslint-disable-next-line radix
    readableTime = `${parseInt(minutes)}:${seconds}`;
    return readableTime;
  };

  populatesearchMeta = searchMeta => {
    let text = '<p></p>';
    if (searchMeta.numFound) {
      if (searchMeta.numFound > 2000) {
        text = 'Your search returned a large number of results.';
        text +=
          ' Showing top 2000 results.<br/>Narrow your search results by refining your search criteria.';
      } else {
        text = `<span className="jResultCount" >${searchMeta.numFound ||
          0}</span> results for <strong class="jSearchTerm" >${searchMeta.Params
          .q || ''}</strong>`;
      }
    }
    return text;
  };

  getWatchLaterActivityId = obj => {
    let activityId = '';
    if (obj && obj._id) {
      activityId = obj._id;
    }

    return activityId.toString();
  };

  render() {
    let videoarray = this.props.data ? this.props.data.Documents : [];
    const searchMeta = this.props.data ? this.props.data.Header : '';

    const pageCountJson = this._getSearchPageCount(
      this.state.pageNum,
      searchMeta.numFound,
    );
    if (videoarray === '') {
      videoarray = [];
    }
    const noresults =
      videoarray.length === 0
        ? 'No results found. Please refine your search criteria.'
        : '';
    let pagination = '';
    const lastpage = Math.ceil(searchMeta.numFound / config.perpage);
    const prevbuttonstate = this.state.pageNum === 1 ? 'hidden' : 'show';
    const nextbuttonstate = this.state.pageNum === lastpage ? 'hidden' : 'show';
    if (videoarray.length > 0) {
      pagination = (
        <div className={s.pagination}>
          <ul className={`${s.curpgcss}`}>
            <li className={`${s.prev} ${s[prevbuttonstate]}`}>
              <a
                href="#0"
                // eslint-disable-next-line css-modules/no-undef-class
                className={s.jPrevious}
                onClick={this.decrementPage}
              >
                Prev
              </a>
            </li>
            {pageCountJson.map(item => (
              <li
                className={
                  this.state.pageNum === item.pageNum ? this.newMethod() : ''
                }
              >
                <a
                  href="#0"
                  value={item.pageNum}
                  className={`${s.active}`}
                  onClick={e => {
                    this.handlePageChangeevent(e, item.pageNum);
                  }}
                >
                  {item.pageNum}
                </a>
              </li>
            ))}

            <li className={`${s.next} ${s[nextbuttonstate]}`}>
              <a href="#0" className="jNext" onClick={this.incrementPage}>
                Next
              </a>
            </li>
          </ul>
        </div>
      );
    }
    if (videoarray.length >= 0) {
      return (
        <div className={s.searchView}>
          <div className={s.column1}>
            <div className={s.search_results}>
              <div className={s.sortby}>
                <p>Sort by :</p>
                <ul className={s.jSortOrder} onClick={this.changesortorder}>
                  <li>
                    <a
                      data-sort-ordrer="score desc"
                      className={
                        this.state.activeSorting === 'score desc'
                          ? s.active
                          : ''
                      }
                      href="#0"
                    >
                      Relevance
                    </a>
                  </li>
                  <li>
                    <a
                      data-sort-ordrer="effectivedate desc"
                      className={
                        this.state.activeSorting === 'effectivedate desc'
                          ? s.active
                          : ''
                      }
                      href="#0"
                    >
                      LATEST
                    </a>
                  </li>
                </ul>
              </div>
              <p
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: this.populatesearchMeta(searchMeta),
                }}
              />
              {videoarray.map(item => {
                const eftDate = new Date(item.effectivedate).getTime();
                //console.log(eftDate);
                const description = this._getDescriptionFromXml(
                  item.mediadescxml,
                );
                const duration = item.mediadurationms
                  ? this._convertMsToReadableTime(item.mediadurationms)
                  : '';
                const obj = {
                  dc: description,
                  dl: eftDate,
                  dm: 't',
                  du: duration,
                  hl: item.title.value,
                  id: item.msid,
                  imageid: `${item.msid}&imgsize=65379`,
                  lpt: eftDate,
                  su: `${item.seopath}/videoshow/${item.msid}.cms`,
                  tn: 'video',
                  upd: eftDate,
                  //views: "3637",
                  wu: `${item.seopath}/videoshow/${item.msid}.cms`,
                };
                return (
                  <Videocard
                    theme="search"
                    data={obj}
                    watchLater={
                      !!_get(this.props.watchLaterObj, item.id, undefined)
                    }
                    activityId={this.getWatchLaterActivityId(
                      !!_get(this.props.watchLaterObj, item.id, undefined),
                    )}
                  />
                );
              })}

              <p className={s.jNoResultsFound}>{noresults}</p>

              {pagination}
            </div>
          </div>
          <div className={s.column2}>
            <Topvideos
              watchLaterObj={this.props.watchLaterObj}
              getWatchLaterActivityId={this.getWatchLaterActivityId}
            />
          </div>
        </div>
      );
    }
    return null;
  }
  newMethod() {
    this.a = '';
    return s.current;
  }
}

Videosearch.propTypes = {
  loadVideosearchDataCount: PropTypes.func.isRequired,
  data: PropTypes.element.isRequired,
  watchLaterObj: PropTypes.shape({}),
  watchLater: PropTypes.shape({}),
  isMobile: PropTypes.bool,
};
Videosearch.defaultProps = {
  watchLaterObj: {},
  watchLater: {},
  isMobile: false,
};
const mapStateToProps = state => ({
  data: state.videosearch.data,
  isMobile: state.isMobile,
});
const mapDispatchtoProps = dispatch => ({
  loadVideosearchDataCount: params => {
    dispatch(loadVideosearchDataCount(params));
  },
});
export default connect(mapStateToProps, mapDispatchtoProps)(Videosearch);
